import { JobsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { jobsKeys } from './jobsKeys';
import type { TCall } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof jobsKeys.workspaceDetail>>;

export const createFetchJobQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ jobId, workspaceId }], signal }: TParams) =>
    call(() => cancelOnSignal(JobsService.getJobById({ jobId, wsid: workspaceId }), signal));
